import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { BrainEstreamComputeRangeService } from 'brain-data/service/brain-estream/brain-estream-compute-range.service';
import {
  loadEstreamComputeRange,
  loadEstreamComputeRangeError,
  loadEstreamComputeRangeSuccess,
} from '../actions/estream-compute-range.action';

@Injectable()
export class EstreamComputeRangeEffects {
  loadEstreamComputeRange$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEstreamComputeRange),
      mergeMap(({ request }) =>
        this.service.computeRange(request).pipe(
          map(response => loadEstreamComputeRangeSuccess({ request, response })),
          catchError((error: Error) =>
            of(loadEstreamComputeRangeError({ request, error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: BrainEstreamComputeRangeService,
  ) {}
}
